import { privacyPolicyEnTranslations } from './privacy-policy.en';
import { privacyPolicyHeTranslations } from './privacy-policy.he';

export const privacyPolicyTranslations = {
  en: privacyPolicyEnTranslations,
  he: privacyPolicyHeTranslations,
} as const;
